module.exports = __webpack_public_path__ + "static/media/androidphone.40759769.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/how-can-be-used/assets/androidphone.svg
// module id = 81
// module chunks = 0